import { render, staticRenderFns } from "./SailDeckDetail.vue?vue&type=template&id=84315ae4&scoped=true&"
import script from "./SailDeckDetail.vue?vue&type=script&lang=js&"
export * from "./SailDeckDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84315ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84315ae4')) {
      api.createRecord('84315ae4', component.options)
    } else {
      api.reload('84315ae4', component.options)
    }
    module.hot.accept("./SailDeckDetail.vue?vue&type=template&id=84315ae4&scoped=true&", function () {
      api.rerender('84315ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/sail/SailDeckDetail.vue"
export default component.exports